import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "pl-3" }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TreeView = _resolveComponent("TreeView", true)!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tree, (branch, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: 'tree-view_level-' + _ctx.level + '_branch-' + index
      }, [
        (branch.children && branch.children.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "branch", _mergeProps({ ref_for: true }, { item: branch.item, level: _ctx.level, name: branch.name, id: branch.id })),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_TreeView, {
                  items: branch.children,
                  branchClick: _ctx.branchClick,
                  level: _ctx.level + 1
                }, {
                  branch: _withCtx(({ item, level, name, id }) => [
                    _renderSlot(_ctx.$slots, "branch", _mergeProps({ ref_for: true }, { item, level, name, id }))
                  ]),
                  leaf: _withCtx(({ item, level, name, id }) => [
                    _renderSlot(_ctx.$slots, "leaf", _mergeProps({ ref_for: true }, { item, level, name, id }))
                  ]),
                  _: 2
                }, 1032, ["items", "branchClick", "level"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "leaf", _mergeProps({ ref_for: true }, { item: branch.item, level: _ctx.level, name: branch.name, id: branch.id }))
            ]))
      ]))
    }), 128))
  ]))
}